import 'styles/thirdparty/font-awesome.css';
import 'styles/thirdparty/bootstrap.css';
import 'styles/thirdparty/owlcarousel.css';
import 'styles/thirdparty/ag-grid.css';
import 'styles/thirdparty/ag-grid-alpine.css';
import 'rc-slider/css';

import 'styles/public/all.scss';
